import { React, useState } from "react";
import Calculator from './calculator'

export default function App() {
    
    const [expression, setExpression] = useState("6 / (2 + 4)*(0.5+2^4) - 4");

    return (
        <div>
            <h3>Reverse Polish Notation</h3>
            <h4>Set the expression (orthodox notation):</h4>
            <div className="details"  style={{marginBottom:10}}>
                <input id='expression' defaultValue={expression} onChange={(e) => setExpression(e.target.value)}/>
            </div>
            <Calculator expression = {expression} />
        </div>
    )
}